import SchemaOrgHead from '../../components/feature/SchemaOrgHead';
import HeroSection from './components/HeroSection';
import ServicesPreview from './components/ServicesPreview';
import AboutPreview from './components/AboutPreview';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'HouseCleaner'],
  '@id': `${siteUrl}/#organization`,
  name: 'Limpieza Pro The Villages FL',
  url: siteUrl,
  description:
    'Empresa de limpieza residencial especializada en post-mudanza, limpieza de ventanas, lavado a presión y valet trash para condominios en el área de The Villages, FL y sus alrededores.',
  telephone: '',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'The Villages',
    addressRegion: 'FL',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 28.9067,
    longitude: -81.9581,
  },
  areaServed: [
    { '@type': 'City', name: 'The Villages' },
    { '@type': 'AdministrativeArea', name: 'Sumter County, FL' },
    { '@type': 'AdministrativeArea', name: 'Marion County, FL' },
  ],
  serviceType: [
    'Limpieza Post-Mudanza',
    'Limpieza Nueva Construcción',
    'Limpieza de Ventanas',
    'Lavado a Presión',
    'Valet Trash para Condominios',
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '09:00',
      closes: '15:00',
    },
  ],
  sameAs: [],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: siteUrl,
  name: 'Limpieza Pro The Villages FL',
  description: 'Servicios profesionales de limpieza residencial en The Villages, FL',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function HomePage() {
  return (
    <>
      <SchemaOrgHead
        schema={[homeSchema, websiteSchema]}
        pageTitle="Servicios Profesionales de Limpieza, The Villages, FL"
        pageDescription="Empresa de limpieza residencial especializada en post-mudanza, limpieza de ventanas, lavado a presión y valet trash para condominios en el área de The Villages, FL y sus alrededores. Cotización gratis."
        canonicalPath="/"
      />
      <main>
        <HeroSection />
        <ServicesPreview />
        <AboutPreview />
        <TestimonialsSection />
        <CtaSection />
      </main>
    </>
  );
}
